module.exports = __webpack_public_path__ + "img/20-r.cebbdbc6.png";